import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import { ImageHeader, ImageHeading } from '../components/OnePager/ImageSectionStyle'
import { NavSpacer, LightBackground, Black, BlackHeading, LogeButtonSlim } from '../components/GeneralStyle'

import rulesHeader from '../images/regelwerk_header.jpg'

import Parse from 'parse'
import renderHTML from 'react-render-html';

@inject('userStore')

@observer
class GolfRules extends Component {

  constructor(props) {
    super(props)

    this.state = {
      rules: ""
    }

    Parse.Config.get().then(async config => {
      let rules = await config.get("RULES")
      rules = rules.replace(new RegExp("h2>", 'g'), "h4>")
      rules = "<style>.ruleContent > *{color:black;} .ruleContent > p > a{text-decoration: underline; color:#337AB8;} .ruleContent > h4 {margin: 35px 0 10px 0; text-transform: uppercase; }</style><div class='ruleContent'>" + rules + "</div>"
      // rules = rules.replace(new RegExp("<p>", 'g'), "<Black>")
      this.setState({ rules })
    })

  }

  componentWillMount() {
    // let all components know that this is the page home
  }

  render() {

    const { rules } = this.state
    const { isAdmin } = this.props.userStore;

    return (
      <div>

        <Grid fluid>
          <NavSpacer />
          <LightBackground className={"fillScreen"}>
            <ImageHeader height={350} background={rulesHeader}>
              <ImageHeading>GOLF REGELWERK</ImageHeading>
            </ImageHeader>
            <Row style={{ padding: 30, maxWidth: 1200, margin: "0 auto" }}>

              { isAdmin &&
                <LogeButtonSlim
                    style={{
                        position: 'relative',
                        display: 'flex',
                        margin: 'auto !important',
                        marginLeft: 0,
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    hoverFontColor={"white"}
                    onClick={() => this.props.history.push("/internal/admin/rules")}
                >
                  Regelwerk bearbeiten
                </LogeButtonSlim>
              }

              <Black>
                {renderHTML(rules)}
              </Black>


              {/* <BlackHeading style={{ textAlign: "left" }}>Zwei gewinnt</BlackHeading>
              <Black>
                Jeder hat das Recht, 2 Buchungen, für max. je 2 Spieler, auf unterschiedlichen Plätzen und an unterschiedlichen Tagen zu tätigen.
                 Weitere Buchungen sind erst nach der gespielten Runde am darauffolgenden Tag möglich.

              </Black>
              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>Buchungen</BlackHeading>
              <Black>Pro Member können max. zwei Startzeiten pro Tag reserviert werden.</Black>

              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>Restplatzbörse</BlackHeading>
              <Black>
                Ab 17.00 dürfen für den darauffolgenden Tag die noch freien Spielrechte zusätzlich gebucht werden.
                Eine Buchung für max. 2 Personen / Buchungsrecht! Diese werden in ROT eingetragen und können zusätzlich zu den 2 regulären Buchungen eingetragen werden.
              </Black>

              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>Stornierung von Buchungen</BlackHeading>
              <Black>
                Kann eine Buchung nicht in Anspruch genommen werden gilt folgende Vorgangsweise: Buchung wird vom Bucher selbst gelöscht und
                im Anschluss wird diese Stornierung unter Angabe von Platz und Datum in der WhatsApp Gruppe bekanntgegeben. z.B. Fontana, 3.3.17, 2 X frei

              </Black>

              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>GOLFCLUB SCHLOSS SCHÖNBORN – EINSCHRÄNKUNGEN</BlackHeading>
              <Black>
                Um auf dieser Anlage spielen zu dürfen sind folgende HCP Voraussetzung:
              </Black>
              <br />
              <Black>
                MO – DO:		HCP 45
              </Black>
              <Black>
                FR – SO & Feiertage:	HCP 36
              </Black>
              <br />


              <Black>
              Mitglieder folgender Golfclubs sind nur mit einer Aufzahlung in der Höhe von € 30,-pro 18 Loch, berechtigt auf Firmenmitgliedschaften zu Spielen.
              </Black>
              <br />
              <Black>
                Golf Direkt <br />
                <span style={{ marginLeft: 30 }}>GC Römergolf</span> <br />
                <span style={{ marginLeft: 30 }}>GC Drautal / Berg</span><br />
                <span style={{ marginLeft: 30 }}>GC Pleiskirchen D</span><br />
                <span style={{ marginLeft: 30 }}> GC Schloss Krugsdorf D</span><br />
                <span style={{ marginLeft: 30 }}> GC Dolomitengolf</span><br />
                GC Marco Polo <br />
                GC Ober den Dachern von Passau GC Guntramsdorf <br />
                GC HSV Wiengolf <br />
                GC Herrensee <br />
                GC Laab im Walde <br />
                GC Neulengbach <br />
                GC Breitenfurt <br />
                GC Golf Maxx <br />
                GC Maria Taferl <br />
                GC Schn6nfeld Neun <br />
                GC Waldhof <br />
                GC Citygolf Vienna <br />
                GC 2000 <br />
                GC Bergergut <br />
                GC Europeangolfclub <br />
                GC Fruhling light <br />

              </Black>
              <br />

              <Black>
                Natürlich sind wir im Golfclub Schloss Schönborn, so wie in allen anderen Partnerclubs, Gäste und haben uns an deren Regeln und Etikette zu halten. Der Golfclub Schloss Schönborn wird Gästen, welche sich nicht an die Gepflogenheiten halten, das Spielrecht entziehen und sie auf Dauer sperren.
              </Black>
              <br />

              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>DIAMOND COUNTRY CLUB / OTTENSTEIN COUNTRY CLUB – EINSCHRÄNKUNGEN</BlackHeading>


              <Black>
              Mitglieder folgender Golfclubs sind nur mit einer Aufzahlung in der Höhe von € 30,-pro 18 Loch, berechtigt auf Firmenmitgliedschaften zu Spielen.
              </Black>
              <br />
              <Black>
              Golf Direkt <br />
                <span style={{ marginLeft: 30 }}>GC Römergolf</span> <br />
                <span style={{ marginLeft: 30 }}>GC Drautal / Berg</span><br />
                <span style={{ marginLeft: 30 }}>GC Pleiskirchen D</span><br />
                <span style={{ marginLeft: 30 }}> GC Schloss Krugsdorf D</span><br />
                <span style={{ marginLeft: 30 }}> GC Dolomitengolf</span><br />
                GC Marco Polo <br />
                GC Ober den Dachern von Passau GC Guntramsdorf <br />
                GC HSV Wiengolf <br />
                GC Herrensee <br />
                GC Laab im Walde <br />
                GC Neulengbach <br />
                GC Breitenfurt <br />
                GC Golf Maxx <br />
                GC Maria Taferl <br />
                GC Schn6nfeld Neun <br />
                GC Waldhof <br />
                GC Citygolf Vienna <br />
                GC 2000 <br />
                GC Bergergut <br />
                GC Europeangolfclub <br />
                GC Fruhling light <br />

              </Black>
              <br />

              <Black>
                Natürlich sind wir im Diamond Country Club / Ottenstein Country Club, so wie in allen anderen Partnerclubs, Gäste und haben uns an deren Regeln und Etikette zu halten. Der Diamond Country Club / Ottenstein Country Club wird Gästen, welche sich nicht an die Gepflogenheiten halten, das Spielrecht entziehen und sie auf Dauer sperren.
              </Black>
              <br />


              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>GOLFCLUB FÖHRENWALD & GOLFCLUB LINSBERG – EINSCHRÄNKUNGEN</BlackHeading>


              <Black>
                Mitglieder folgender Golfclubs sind nur mit einer Aufzahlung in der Höhe von € 20,-  pro 18 Loch, berechtigt auf die Loge-Firmenmitgliedschaft zu Spielen.
              </Black>
              <br />
              <Black>
                Golf Direkt <br />
                <span style={{ marginLeft: 30 }}>GC Römergolf</span> <br />
                <span style={{ marginLeft: 30 }}>GC Drautal / Berg</span><br />
                GC Marco Polo <br />
                GC Über den Dächern von Passau <br />
                GC Guntramsdorf <br />
                GC HSV Wiengolf<br />
                GC Herrensee <br />
                GC Laab im Walde <br />
                GC Neulengbach <br />
                GC Breitenfurt<br />
                GC Golf Maxx<br />
                GC Maria Taferl <br />
                GC Schönfeld Neun <br />
                GC Waldhof<br />
                GC Citygolf Vienna <br />
                GC 2000 <br />
                GC Bergergut <br />
                GC Europeangolfclub <br />


              </Black>
              <br />

              <Black>
                Natürlich sind wir im Golfclub Föhrenwald & Golfclub Linsberg, so wie in allen anderen Partnerclubs, Gäste und haben uns an deren Regeln und Etikette zu halten. Der Golfclub Föhrenwald & Golfclub Linsberg wird Gästen, welche sich nicht an die Gepflogenheiten halten, das Spielrecht entziehen und sie auf Dauer sperren.
              </Black>
              <br />

              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>GC SCHLADMING DACHSTEIN - EINSCHRÄNKUNGEN</BlackHeading>
              <Black>
                Unsere Spielrechte gelten NICHT für Turniere!
              </Black>
<br />

              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>GC SPILLERN - EINSCHRÄNKUNGEN</BlackHeading>
              <Black>
                Unsere Spielrechte gelten NICHT für Turniere an Wochenenden und Feiertagen!
              </Black>

              <br />
              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>GC AM MONDSEE - EINSCHRÄNKUNGEN</BlackHeading>
              <Black>
                Unsere Spielrechte gelten NICHT für Turniere!
              </Black>
<br />
	    <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>  GOLF & COUNTRY CLUB BRUNN - EINSCHRÄNKUNGEN</BlackHeading>
              <Black>
                Unsere Spielrechte gelten NICHT für Turniere!
              </Black>
              <br />
              <BlackHeading style={{ textAlign: "left", marginTop: 35 }}>GOLFCLUB FONTANA – EINSCHRÄNKUNGEN</BlackHeading>
              <Black>
                Um auf dieser Anlage spielen zu dürfen sind folgende HCP Voraussetzung:
              </Black>
              <Black>
                MO – DO:		HCP 45
              </Black>
              <Black>
                FR – SO & Feiertage:	HCP 36
              </Black>
              <br />
              <Black>
                Ehemalige Fontana-Mitglieder können über die Spielrechte von The Loge nicht in Fontana spielen!
              </Black> */}




            </Row>
          </LightBackground>
        </Grid>

      </div >
    );
  }
}


export default GolfRules;



// WEBPACK FOOTER //
// /src/pages/GolfRules.js